export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/go-icon.svg?d23a4b881abf2128ae246ab1ef33636a";